__turbopack_context__.v({
  "accordionButton": "ProductDetails-module__9u04aq__accordionButton",
  "accordionContent": "ProductDetails-module__9u04aq__accordionContent",
  "accordionItem": "ProductDetails-module__9u04aq__accordionItem",
  "accordionItemWrapper": "ProductDetails-module__9u04aq__accordionItemWrapper",
  "accordionList": "ProductDetails-module__9u04aq__accordionList",
  "accordionSection": "ProductDetails-module__9u04aq__accordionSection",
  "accordionSubtitle": "ProductDetails-module__9u04aq__accordionSubtitle",
  "accordionTitle": "ProductDetails-module__9u04aq__accordionTitle",
  "contentWrapper": "ProductDetails-module__9u04aq__contentWrapper",
  "headingWrapper": "ProductDetails-module__9u04aq__headingWrapper",
  "imageSection": "ProductDetails-module__9u04aq__imageSection",
  "plusIcon": "ProductDetails-module__9u04aq__plusIcon",
  "section": "ProductDetails-module__9u04aq__section",
  "swapContainer": "ProductDetails-module__9u04aq__swapContainer",
  "swapImage": "ProductDetails-module__9u04aq__swapImage",
  "swapLayer": "ProductDetails-module__9u04aq__swapLayer",
});
